<meta name="viewport" content="width=device-width, initial-scale=1.0">

<div class="mobile">
  <div>
    <div class="header pb-4 pt-5 pt-md-4"
      style="background-color: #fbb034;z-index: 50; background-image: linear-gradient(315deg, #ffdd00 0%, #fbb034 74%); height: 10px; margin-bottom: 16px;">
    </div>
    <div class="tw-bg-white tw-m-4 tw-p-3 -tw-mt-20 tw-relative tw-z-50 tw-rounded-lg
            tw-overflow-y-auto tw-max-h-[90vh]
            md:tw-overflow-visible md:tw-max-h-none">
      <div class="tw-font-medium tw-text-black tw-p-1">Verify Timesheet</div>
      <div class="tw-flex">
        <!-- Filter Section -->
        <div class="tw-flex tw-w-full tw-gap-2 tw-p-1 tw-justify-between tw-mb-2">
          <!-- Year Dropdown -->
          <select [(ngModel)]="searchValueYear" (ngModelChange)="onYearChange()"
            class="tw-text-xs tw-flex-1 tw-rounded-full tw-font-meduim tw-px-2 tw-py-1 tw-bg-white tw-shadow-md tw-text-center">
            <option value="">Year</option>
            <option *ngFor="let year of getSortedYears()" [value]="year">
              {{year}}
            </option>
          </select>

          <!-- Month Dropdown -->
          <select [(ngModel)]="searchValueMonth" (ngModelChange)="onMonthChange()"
            class="tw-text-xs  tw-flex-1 tw-rounded-full tw-font-meduim  tw-px-2 tw-py-1 tw-bg-white tw-shadow-md tw-text-center">
            <option value="">Month</option>
            <option value="1">Jan</option>
            <option value="2">Feb</option>
            <option value="3">Mar</option>
            <option value="4">Apr</option>
            <option value="5">May</option>
            <option value="6">Jun</option>
            <option value="7">Jul</option>
            <option value="8">Aug</option>
            <option value="9">Sep</option>
            <option value="10">Oct</option>
            <option value="11">Nov</option>
            <option value="12">Dec</option>
          </select>

          <!-- Status Dropdown -->
          <select [(ngModel)]="nowTab" (ngModelChange)="changeTab($event); selectedPage = 0"
            class="tw-text-xs tw-flex-2  tw-rounded-full  tw-font-meduim  tw-px-1 tw-py-1 tw-bg-white tw-shadow-md tw-text-center">
            <option value="1">Pending</option>
            <option value="7">Not Submit</option>
            <option value="2">Revising</option>
            <option *ngIf="rolename.includes('ADMIN') || rolename.includes('MANAGER')" value="5">HR Revised</option>
            <option value="6">Pending HR Approval</option>
            <option value="3">Approved</option>
          </select>
        </div>
      </div>
      <div class="tw-mx-2 tw-rounded-2xl tw-border tw-px-2 tw-border-gray-300 tw-bg-white tw-p-4 tw-shadow-sm tw-mb-4"
        *ngFor="let userMainTimesheetList of _userMainTimesheetList; let i = index">

        <!-- Name Section -->
        <div class="tw-flex tw-items-center tw-mb-2 tw-pb-1 tw-border-b tw-border-gray-200">
          <span class="tw-text-gray-600 tw-text-xs tw-font-light tw-min-w-[80px]">Name:</span>
          <span class="tw-text-gray-800 tw-text-xs tw-font-meduim">
            {{userMainTimesheetList.firstName}} {{userMainTimesheetList.lastName}}
          </span>
        </div>

        <!-- Month Section -->
        <div class="tw-flex tw-items-center tw-mb-2 tw-pb-1 tw-border-b tw-border-gray-200">
          <span class="tw-text-gray-600 tw-text-xs tw-font-light tw-min-w-[80px]">Month:</span>
          <span class="tw-text-gray-800 tw-text-xs tw-font-meduim">
            {{userMainTimesheetList.month <= 12 ? (userMainTimesheetList.month | month) + "/" +
              userMainTimesheetList.year : "December 26-31/" + userMainTimesheetList.year}} </span>
        </div>

        <!-- Status Section -->
        <div class="tw-flex tw-items-center tw-mb-2 tw-pb-1 tw-border-b tw-border-gray-200">
          <span class="tw-text-gray-600 tw-text-xs tw-font-light tw-min-w-[80px]">Status:</span>
          <span [ngClass]="{
      'tw-text-blue-600': userMainTimesheetList.status === 'P',
      'tw-text-green-600': userMainTimesheetList.status === 'A',
      'tw-text-red-600': userMainTimesheetList.status === 'R',
      'tw-text-orange-600': userMainTimesheetList.status === 'V'
    }" class="tw-font-meduim tw-text-xs">
            {{userMainTimesheetList.status === 'P' ? 'Pending Approve' :
            userMainTimesheetList.status === 'A' ? 'Approved' :
            userMainTimesheetList.status === 'A' ? 'HR Revised' :
            userMainTimesheetList.status === 'M' ? 'Pending HR Approval' :
            userMainTimesheetList.status === 'R' ? 'Rejected' :
            userMainTimesheetList.status === 'V' ? 'Revising' : userMainTimesheetList.status}}
          </span>
        </div>

        <!-- Action Buttons -->
        <div class="tw-flex tw-items-center tw-gap-3">
          <!-- View Icon -->
          <button class="tw-flex-2 tw-items-center tw-justify-center tw-w-10 tw-pl-2 "
            (click)="goToViewVerifyTimesheet(userMainTimesheetList.id, userMainTimesheetList.month, userMainTimesheetList.year)">


            <img src="assets/img/icons/view.png" class="tw-w-6 tw-h-6 tw-text-blue-600">
          </button>

          <!-- Approve Button -->
          <button *ngIf="userMainTimesheetList.status === 'P' || userMainTimesheetList.status === 'M'" [disabled]="!(
    (
      userMainTimesheetList.status === 'P' && 
      (
        userMainTimesheetList.positionId == 3 || 
        userMainTimesheetList.positionId == 5 || 
        userMainTimesheetList.leadId == 181 ||
        currentUserID == userMainTimesheetList.leadId 
      )
    )
    ||
    (
      userMainTimesheetList.status === 'M' && 
      rolename.includes('ADMIN')
    )
  )" class="tw-flex-1 tw-px-2 tw-py-1 tw-bg-green-500 tw-text-xs hover:tw-bg-green-600 tw-text-white tw-font-medium tw-rounded-lg tw-transition-colors disabled:tw-opacity-50 disabled:tw-cursor-not-allowed"
            (click)="onClickApprove(userMainTimesheetList)">
            Approve
          </button>


          <!-- Revise Button -->
          <button *ngIf="userMainTimesheetList.status === 'P' || userMainTimesheetList.status === 'M'" [disabled]="!(
    (
      userMainTimesheetList.status === 'P' && 
      (
        userMainTimesheetList.positionId == 3 || 
        userMainTimesheetList.leadId == 181 ||
        currentUserID == userMainTimesheetList.leadId 
      )
    )
    ||
    (
      userMainTimesheetList.status === 'M' && 
      rolename.includes('ADMIN')
    )
  )" class="tw-flex-1 tw-px-2 tw-py-1 tw-bg-blue-500 tw-text-xs hover:tw-bg-blue-600 tw-text-white tw-font-medium tw-rounded-lg tw-transition-colors disabled:tw-opacity-50 disabled:tw-cursor-not-allowed"
            (click)="onClickRevise(userMainTimesheetList)">
            Revise
          </button>



          <!-- Employee Revise Button สำหรับ status 'H' -->
          <button *ngIf="userMainTimesheetList.status === 'H'" [disabled]="!canEmployeeRevise(userMainTimesheetList)"
            type="button"
            class="tw-flex-1 tw-px-2 tw-py-1 tw-bg-blue-500 tw-text-xs hover:tw-bg-blue-600 tw-text-white tw-font-medium tw-rounded-lg tw-transition-colors disabled:tw-opacity-50 disabled:tw-cursor-not-allowed"
            (click)="onClickEmployeeRevise(userMainTimesheetList)">
            Employee Revise
          </button>
        </div>

      </div>
    </div>
  </div>
</div>

<div class="pc">
  <div class="header pb-7 pt-5 pt-md-4" style="
    background-color: #fbb034;
    background-image: linear-gradient(315deg, #ffdd00 0%, #fbb034 74%);
    height: 20px;
    margin-bottom: 16px;">

    <div class="container-fluid"></div>
  </div>
  <!-- ****************************************************************** -->
  <div class="container-fluid mt--7">
    <!-- Table -->
    <div class="row">
      <div class="col">
        <div class="card shadow" style="border-radius: 15px;">
          <div class="card-header" style="border-radius: 15px;">
            <div class="header-section">
              <div class="title-search-row">
                <h2 class="title" style="font-size: 25px;">Verify Timesheet</h2>

                <div class="control-group font-weight: 500;">
                  <ng-container *ngIf="rolename.includes('ADMIN')">
                    <select class="form-control select-compact" [(ngModel)]="selectedManager"
                      (ngModelChange)="onManagerChange()" style="width: 300px;">
                      <option [ngValue]="null">Select Manager</option>
                      <option *ngFor="let lead of allLeads" [ngValue]="lead.id">
                        {{ lead.displayName }}
                      </option>
                    </select>
                    <ng-template #allLeadSelected *ngFor="let lead of uniqueLeads" [ngValue]="lead.id">
                      <div class="lead-pill">
                        <span>All Leads</span>
                        <button type="button" class="form-control select-compact"
                          (click)="clearLeadSelection()">Change</button>
                      </div>
                    </ng-template>
                  </ng-container>

                  <select class="form-control select-compact" [(ngModel)]="searchValueMonth"
                    (ngModelChange)="onMonthChange()">
                    <option value="">Month</option>
                    <option *ngFor="let month of getMonthNumbers()" [value]="month">
                      {{month}}
                    </option>
                  </select>

                  <select class="form-control select-compact" [(ngModel)]="searchValueYear"
                    (ngModelChange)="onYearChange()">
                    <option value="">Year</option>
                    <option *ngFor="let year of getSortedYears()" [value]="year">
                      {{year}}
                    </option>
                  </select>

                  <div class="search-box font-weight: 500;" style="width: 300px;">
                    <img src="assets/img/icons/search.png" alt="Search icon" class="search-icon" />
                    <input type="text" class="form-control" placeholder="Search" [(ngModel)]="searchValue">
                    <span class="clear-search" *ngIf="searchValue" (click)="clearSearch()">×</span>
                  </div>

                  <div class="button-group">
                    <button class="btn btn-primary" (click)="onSearch()">Search</button>
                    <button class="btn btn-secondary" (click)="onClear()">Clear</button>
                  </div>
                </div>


              </div>
              <div>
                <span class="text-danger" style="margin-left: 20px; font-weight: bold;">*HR Revise และ Pending HR
                  Approve
                  จะใช้ก็ต่อเมื่อ HR
                  ตรวจ
                  Timesheet ที่ Approved แล้วพบความผิดปกติจะส่งกลับมายัง Manager
                  เพื่อทำการแก้ไข*</span>
              </div>
            </div>
            <!-- Search Controls -->



            <!-- Tab Navigation -->
            <!-- change tab with export buttons -->
            <div class="d-flex justify-content-between align-items-center" style="font-weight: bold;">
              <div class="d-flex tw-me-1">
                <div (click)="changeTab('1'); selectedPage = 0" role="button" class="px-2 py-2 {{
                  nowTab == '1' && 'border-bottom border-warning'
                }}">
                  Pending <span class="tw-text-[#FBA927] tw-ps-1">{{statusMap.P ?? 0}}</span>
                </div>
                <div (click)="changeTab('7'); selectedPage = 0" role="button" class="px-2 py-2 {{
                  nowTab == '7' && 'border-bottom border-warning'
                }}">
                  Not Submit <span class="tw-text-[#FBA927] tw-ps-1">{{statusMap.N ?? 0}}</span>
                </div>
                <div (click)="changeTab('2'); selectedPage = 0" role="button" class="px-2 py-2 {{
                  nowTab == '2' && 'border-bottom border-warning'
                }}">
                  Revising <span class="tw-text-[#FBA927] tw-ps-1">{{statusMap.V ?? 0}}</span>
                </div>
                <div *ngIf="rolename.includes('ADMIN') || rolename.includes('MANAGER')" class="px-2 py-2"
                  (click)="changeTab('5'); selectedPage = 0" role="button" class="px-2 py-2 {{
                  nowTab == '5' && 'border-bottom border-warning'
                }}">
                  HR Revised <span class="tw-text-[#FBA927] tw-ps-1">{{statusMap.H ?? 0}}</span>
                </div>
                <div (click)="changeTab('6'); selectedPage = 0" role="button" class="px-2 py-2 {{
                  nowTab == '6' && 'border-bottom border-warning'
                }}">
                  Pending HR Approval <span class="tw-text-[#FBA927] tw-ps-1">{{statusMap.M ?? 0}}</span>
                </div>
                <div (click)="changeTab('3'); selectedPage = 0" role="button" class="px-2 py-2 {{
                  nowTab == '3' && 'border-bottom border-warning'
                }}">
                  Approved 
                </div>
                <div hidden (click)="changeTab('4'); selectedPage = 0" role="button" class="px-2 py-2 {{
                  nowTab == '4' && 'border-bottom border-warning'
                }}">
                  Rejected
                </div>
              </div>

              <div class="d-flex align-items-center">
                <button class="btn d-flex align-items-center" type="button" (click)="exportMandayData()">
                  <img src="assets/img/icons/Download.png" alt="Download">
                  <span>Manday Data</span>
                </button>
                <button class="btn d-flex align-items-center" type="button" (click)="exportSiteCostData()">
                  <img src="assets/img/icons/Download.png" alt="Download">
                  <span>Site Cost</span>
                </button>
                <button class="btn d-flex align-items-center" type="button"
                  (click)="exportMandayProjectYear()">
                  <img src="assets/img/icons/Download.png" alt="Download">
                  <span>Annual Summary</span>
                </button>
              </div>
            </div>
          </div>


          <div class="table-responsive mt-10" style="height: 50vh; overflow-y: auto;" id="managerTable">
            <table class="table align-items-center" style="border-collapse: separate; border-spacing: 0 0px">
              <thead class="thead-light">
                <tr>
                  <th style="width: 5%" scope="col" class="text-center font-size" (click)="sort(colId, booleanValue)">
                    No.
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                      class="bi bi-chevron-expand" viewBox="0 0 16 16">
                      <path fill-rule="evenodd"
                        d="M3.646 9.146a.5.5 0 0 1 .708 0L8 12.793l3.646-3.647a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 0-.708zm0-2.292a.5.5 0 0 0 .708 0L8 3.207l3.646 3.647a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 0 0 0 .708z" />
                    </svg>
                  </th>
                  <th style="width: 25%" scope="col" class="text-center font-size"
                    (click)="sort(colEmployee, booleanValue)">
                    Employee
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                      class="bi bi-chevron-expand" viewBox="0 0 16 16">
                      <path fill-rule="evenodd"
                        d="M3.646 9.146a.5.5 0 0 1 .708 0L8 12.793l3.646-3.647a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 0-.708zm0-2.292a.5.5 0 0 0 .708 0L8 3.207l3.646 3.647a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 0 0 0 .708z" />
                    </svg>
                  </th>
                  <th class="text-center" style="width: 20%" *ngIf="rolename.includes('ADMIN')">
                    Lead
                  </th>
                  <th style="width: 20%" scope="col" class="text-center font-size"
                    (click)="sort(colDate, booleanValue)">
                    Month/Year
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                      class="bi bi-chevron-expand" viewBox="0 0 16 16">
                      <path fill-rule="evenodd"
                        d="M3.646 9.146a.5.5 0 0 1 .708 0L8 12.793l3.646-3.647a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 0-.708zm0-2.292a.5.5 0 0 0 .708 0L8 3.207l3.646 3.647a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 0 0 0 .708z" />
                    </svg>
                  </th>
                  <th style="width: 20%" scope="col" class="text-center font-size">
                    Status
                  </th>
                  <th *ngIf="nowTab == '3' && rolename.includes('ADMIN')" style="width: 7%" scope="col"
                    class="text-center font-size">
                    Revised
                  </th>
                  <th style="width: 10%" scope="col" class="text-center font-size" *ngIf="nowTab == '1'">
                    Action
                  </th>
                  <th style="width: 10%" scope="col" class="text-center font-size" *ngIf="
                    (nowTab == '3' || nowTab == '6') &&
                    rolename.includes('ADMIN')
                  ">
                    Action
                  </th>
                  <th style="width: 7%" scope="col" class="text-center font-size" *ngIf="nowTab == '5'">
                    Reason
                  </th>
                  <th style="width: 10%" scope="col" class="text-center font-size" *ngIf="nowTab == '5'">
                    Action
                    <span class="info-icon">i
                      <span class="info-text">ส่งให้พนักงานแก้ไข Timesheet ด้วยตนเอง</span>
                    </span>


                  </th>

                </tr>
              </thead>
              <tbody>
                <tr *ngFor="
                  let userMainTimesheetList of _userMainTimesheetList;
                  let i = index
                ">
                  <th scope="row" class="text-center font-size">
                    {{ i + 1 + startIndex }}
                  </th>
                  <td class="text-left font-size">
                    <span [innerHTML]="
                    isSearch
                      ? printText(userMainTimesheetList.firstName) +
                        ' ' +
                        printText(userMainTimesheetList.lastName) +
                        ' ' +
                        '(' +
                        printText(userMainTimesheetList.nickNameTh) +
                        ')'
                      : printText(userMainTimesheetList.firstName) +
                        ' ' +
                        printText(userMainTimesheetList.lastName) +
                        ' ' +
                        '(' +
                        printText(userMainTimesheetList.nickNameTh) +
                        ')'
                  "></span>
                    <span *ngIf="userMainTimesheetList.userStatus === 'Resign'" class="resign-badge">Resigned</span>
                  </td>
                  <td class="text-center" *ngIf="rolename.includes('ADMIN')">
                    {{ userMainTimesheetList.leadName }} ({{
                    userMainTimesheetList.leadNickNameTh
                    }})
                  </td>
                  <td class="text-center font-size">
                    <span *ngIf="nowTab == '7'">
                      {{
                      userMainTimesheetList.month <= 12 ? (userMainTimesheetList.month | month) + "/" +
                        userMainTimesheetList.year : "December 26-31/" + userMainTimesheetList.year }} </span>
                        <button *ngIf="nowTab != '7'" type="button " class="btn btn-link" (click)="
                      goToViewVerifyTimesheet(
                        userMainTimesheetList.id,
                        userMainTimesheetList.month,
                        userMainTimesheetList.year
                      )
                    ">
                          <span>
                            {{
                            userMainTimesheetList.month <= 12 ? (userMainTimesheetList.month | month) + "/" +
                              userMainTimesheetList.year : "December 26-31/" + userMainTimesheetList.year }} </span>
                        </button>
                  </td>
                  <td class="text-center">
                    <ng-template [ngIf]="userMainTimesheetList.status == 'P'">
                      <span style="color: #6155F5" class="badge badge-dot mr-4 ">
                        Pending Approval
                      </span>
                    </ng-template>
                    <ng-template [ngIf]="userMainTimesheetList.status == 'R'">
                      <span class="badge badge-dot mr-4 text-danger">
                        Rejected
                      </span>
                    </ng-template>
                    <ng-template [ngIf]="userMainTimesheetList.status == 'V'">
                      <span style="color: #6155F5" class="badge badge-dot mr-4"> Revising </span>
                    </ng-template>
                    <ng-template [ngIf]="userMainTimesheetList.status == 'A'">
                      <span style="color: #34C759;" class="badge badge-dot mr-4">
                        Approved
                      </span>
                    </ng-template>
                    <ng-template [ngIf]="userMainTimesheetList.status == 'H'">
                      <span style="color: #6155F5" class="badge badge-dot mr-4">
                        HR Revised</span>
                    </ng-template>
                    <ng-template [ngIf]="userMainTimesheetList.status == 'M'">
                      <span style="color: #6155F5" class="badge badge-dot mr-4 ">
                        Pending HR Approval</span>
                    </ng-template>
                    <ng-template [ngIf]="userMainTimesheetList.status == 'N'">
                      <span style="color: #FBA927;" class="badge badge-dot mr-4">
                        Not Submit</span>
                    </ng-template>
                  </td>
                  <!-- <td class="text-center font-size">{{userMainTimesheetList.status
                                    | status}}</td> -->

                  <!-- เพิ่ม !(userMainTimesheetList.status == 'P' && (userMainTimesheetList.positionId == 3 || userMainTimesheetList.positionId == 5)) เพื่อกำหนดค่าการเปิดปิดปุ่ม-->
                  <td class="w-100 text-center font-size" *ngIf="nowTab == '1' && rolename.includes('ADMIN')">
                    <button [disabled]="
                      !(
                        userMainTimesheetList.status == 'P' &&
                        (userMainTimesheetList.positionId == 3 ||
                          userMainTimesheetList.positionId == 5 ||
                          userMainTimesheetList.leadId == 181 ||
                          this.currentUserID == userMainTimesheetList.leadId)
                      )
                    " type="button" class="btn btn-success"
                      style="height: 40px; width: 100px; border-radius: 10px;  display: inline-flex; align-items: center; justify-content: center;"
                      (click)="onClickApprove(userMainTimesheetList)">
                      Approve
                    </button>
                    <button [disabled]="
                      !(
                        userMainTimesheetList.status == 'P' &&
                        (userMainTimesheetList.positionId == 3 ||
                           userMainTimesheetList.leadId == 181 ||
                          this.currentUserID == userMainTimesheetList.leadId)
                      )
                    " type="button" class="btn btn-revise"
                      style="height: 40px; width: 70px; border-radius: 10px;  display: inline-flex; align-items: center; justify-content: center;"
                      data-bs-toggle="modal" data-bs-target="#staticBackdrop"
                      (click)="onClickRevise(userMainTimesheetList)">
                      Revise
                    </button>
                    <!-- <button hidden [disabled]="
                      !(
                        userMainTimesheetList.status == 'P' &&
                        (userMainTimesheetList.positionId == 3 ||
                          userMainTimesheetList.positionId == 5 ||
                          this.currentUserID == userMainTimesheetList.leadId)
                      )
                    " type="button" class="btn btn-danger" data-bs-toggle="modal" data-bs-target="#staticBackdrop"
                    (click)="onClickReject(userMainTimesheetList)">
                    Reject
                  </button> -->
                  </td>
                  <!-- **************************************************************************************************************** -->

                  <!-- *****************************************APPROVE,REJECT,REVISE FOR MANAGER ***************************************-->
                  <td class="text-center font-size" *ngIf="nowTab == '1' && rolename.includes('MANAGER')">
                    <button [disabled]="!(userMainTimesheetList.status == 'P')" type="button" class="btn btn-success"
                      style="height: 40px; width: 100px; border-radius: 10px; margin-right: 0.5rem !important; display: inline-flex; align-items: center; justify-content: center;"
                      (click)="onClickApprove(userMainTimesheetList)">
                      Approve
                    </button>
                    <button [disabled]="!(userMainTimesheetList.status == 'P')" type="button" class="btn btn-revise"
                      style="height: 40px; width: 70px; border-radius: 10px; margin-right: 0 !important; display: inline-flex; align-items: center; justify-content: center;"
                      data-bs-toggle="modal" data-bs-target="#staticBackdrop"
                      (click)="openDiaLogClick(modalManagerRevise)">
                      Revise
                    </button>
                    <ng-template #modalManagerRevise let-modalUp>
                      <div>
                        <div class="modal-header">
                          <h2 class="modal-title">Reason</h2>
                          <i style="cursor: pointer; font-size: 20px" class="fa-solid fa-xmark" data-bs-dismiss="modal"
                            (click)="modalUp.dismiss('Cross click')"></i>
                        </div>
                        <div class="modal-body" style="padding-bottom: 16px; padding-top: 0px;">
                          <textarea class="mb-3 tw-mx-3" style="min-height: 150px; resize: none" class="form-control"
                          [(ngModel)]="reason" placeholder="Reason"></textarea>
                          <p *ngIf="isReasonInvalid" class="tw-font-bold text-danger tw-flex tw-justify-center tw-mt-1">*Require Your Reason</p>
                          <div class="d-flex justify-content-center mt-3">
                            <button type="button" class="btn btn-primary"
                              (click)="onClickRevise(userMainTimesheetList)">
                              Confirm
                            </button>
                            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"
                              (click)="modalUp.dismiss('Cross click')">
                              Back
                            </button>
                          </div>
                        </div>
                      </div>
                    </ng-template>
                    <button hidden [disabled]="!(userMainTimesheetList.status == 'P')" type="button"
                      class="btn btn-danger" data-bs-toggle="modal" data-bs-target="#staticBackdrop"
                      (click)="onClickReject(userMainTimesheetList)">
                      Reject
                    </button>

                    <!-- *************************************************************************** -->
                  </td>
                  <td *ngIf="nowTab == '3' && rolename.includes('ADMIN')" class="text-center">
                    <input disabled type="checkbox" style="transform: scale(1.5)"
                      [checked]="userMainTimesheetList.revise === '1'" />
                  </td>
                  <td *ngIf="nowTab == '3' && rolename.includes('ADMIN')" class="text-center">
                    <button [disabled]="!(userMainTimesheetList.status == 'A')" type="button" class="btn btn-danger"
                      style="height: 40px; width: 100px; border-radius: 10px; display: inline-flex; align-items: center; justify-content: center;"
                      data-bs-toggle="modal" data-bs-target="#staticBackdrop" (click)="openDiaLogClick(modalHrRevise)">
                      HR Revise
                    </button>
                    <ng-template #modalHrRevise let-modalUp>
                      <div>
                        <div class="modal-header">
                          <h2 class="modal-title">Reason</h2>
                          <i style="cursor: pointer; font-size: 20px" class="fa-solid fa-xmark" data-bs-dismiss="modal"
                            (click)="modalUp.dismiss('Cross click')"></i>
                        </div>
                        <div class="modal-body" style="padding-bottom: 16px; padding-top: 0px;">
                          <textarea class="mb-3 tw-mx-3" style="min-height: 150px; resize: none" class="form-control"
                            [(ngModel)]="reason" placeholder="Reason"></textarea>
                            <p *ngIf="isReasonInvalid" class="tw-font-bold text-danger tw-flex tw-justify-center tw-mt-1">*Require Your Reason</p>
                          <div class="d-flex justify-content-center mt-3">
                            <button type="button" class="btn btn-primary"
                              (click)="onClickHrRevise(userMainTimesheetList)">
                              Confirm
                            </button>
                            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"
                              (click)="modalUp.dismiss('Cross click')">
                              Back
                            </button>
                          </div>
                        </div>
                      </div>
                    </ng-template>
                  </td>
                  <td *ngIf="nowTab == '5'" class="text-center">
                    {{ userMainTimesheetList.reason }}
                  </td>
                  <td *ngIf="nowTab == '5'" class="text-center">
                    <button class="tw-px-4" [disabled]="!canEmployeeRevise(userMainTimesheetList)" type="button"
                      class="btn btn-primary"
                      style="height: 40px; width: 160px; border-radius: 10px; display: inline-flex; align-items: center; justify-content: center;"
                      (click)="onClickEmployeeRevise(userMainTimesheetList)" [ngStyle]="{
      'opacity': canEmployeeRevise(userMainTimesheetList) ? '1' : '0.5', 
      'cursor': canEmployeeRevise(userMainTimesheetList) ? 'pointer' : 'not-allowed'
    }">
                      Employee Revise
                    </button>
                  </td>

                  <td *ngIf="nowTab == '6' && rolename.includes('ADMIN')" class="text-center">
                    <button [disabled]="!(userMainTimesheetList.status == 'M')" type="button" class="btn btn-success"
                      style="height: 40px; width: 100px; border-radius: 10px;  display: inline-flex; align-items: center; justify-content: center;"
                      (click)="onClickApprove(userMainTimesheetList)">
                      Approve
                    </button>
                    <button [disabled]="!(userMainTimesheetList.status == 'M')" type="button" class="btn btn-danger"
                      style="height: 40px; width: 100px; border-radius: 10px; display: inline-flex; align-items: center; justify-content: center;"
                      data-bs-toggle="modal" data-bs-target="#staticBackdrop" (click)="openDiaLogClick(modalHrRevise)">
                      HR Revise
                    </button>
                    <ng-template #modalHrRevise let-modalUp>
                      <div>
                        <div class="modal-header">
                          <h2 class="modal-title">Reason</h2>
                          <i style="cursor: pointer; font-size: 20px" class="fa-solid fa-xmark" data-bs-dismiss="modal"
                            (click)="modalUp.dismiss('Cross click')"></i>
                        </div>
                        <div class="modal-body">
                          <textarea class="mb-3" style="min-height: 150px; resize: none" class="form-control"
                            [(ngModel)]="reason" placeholder="Reason"></textarea>
                          <p *ngIf="isReasonInvalid" class="tw-font-bold text-danger tw-flex tw-justify-center tw-mt-1">*Require Your Reason</p>
                          <div class="d-flex justify-content-center mt-3">
                            <button type="button" class="btn btn-primary"
                              (click)="onClickHrRevise(userMainTimesheetList)">
                              Confirm
                            </button>
                            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"
                              (click)="modalUp.dismiss('Cross click')">
                              Back
                            </button>
                          </div>
                        </div>
                      </div>
                    </ng-template>
                  </td>
                  <!-- <td *ngIf="nowTab == '5'" class="text-center">
                  <button
                    [disabled]="rolename.includes('MANAGER')"
                    class="btn btn-warning"
                    (click)="goToEditTimesheet(userMainTimesheetList)"
                  >
                    Edit
                  </button>
                </td> -->
                </tr>
              </tbody>
            </table>
          </div>
          <nav aria-label="Page navigation example">
            <ul class="pagination justify-content-end">
              <!-- <li *ngFor="let in of counter(pagingLength); let i = index" class="page-item">
              <a style="cursor: hand; cursor: pointer" class="page-link" (click)="changePage(i)"
                [ngClass]="{ 'selected-page': i === selectedPage }" (click)="selectedPage = i">{{ i + 1 }}</a>
            </li> -->
              <div class="d-flex justify-content-center align-items-center mr-2">
                <span class="text-dark mr-1">Page</span>
                <span class="text-dark">{{ currentPage + 1 }} / {{ pagingLength }}</span>
              </div>
              <li class="page-item" [class.disabled]="currentPage === 0">
                <i class="fa-solid fa-backward-step page-link" (click)="setPage(0)" role="button"></i>
              </li>
              <li class="page-item" [class.disabled]="currentPage === 0">
                <i class="fa-solid fa-caret-left page-link" (click)="setPage(currentPage - 1)" role="button"></i>
              </li>
              <li class="page-item" *ngFor="let page of pages" [class.active]="page === currentPage + 1">
                <a class="page-link page-number-btn" (click)="setPage(page - 1)" role="button">{{
                  page
                  }}</a>
              </li>
              <li class="page-item" [class.disabled]="currentPage === pagingLength - 1">
                <i class="fa-solid fa-caret-right page-link" (click)="setPage(currentPage + 1)" role="button"></i>
              </li>
              <li class="page-item" [class.disabled]="currentPage === pagingLength - 1">
                <i class="fa-solid fa-forward-step page-link" (click)="setPage(pagingLength - 1)" role="button"></i>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
  </div>
  <table hidden #tableMandayProject style="text-align: center">
    <thead style="background-color: whitesmoke">
      <tr>
        <th colspan="19">
          <h1 style="font-weight: bold">B3 Technology Co., Ltd</h1>
        </th>
      </tr>
      <tr>
        <td colspan="19">Time Sheet and Delivery</td>
      </tr>
      <tr>
        <td id="year" colspan="19">{{ year }} Project Manday Overview</td>
      </tr>
      <tr>
        <td colspan="1" rowspan="2">Project code</td>
        <td colspan="1" rowspan="2">Project name</td>
        <td colspan="1" rowspan="2">Manday project</td>
        <td colspan="12">Mandayที่ใช้ไป (รายเดือน)</td>
        <td colspan="1" rowspan="2">Mandayที่ใช้ไป (รวมทั้งปี)</td>
        <td colspan="1" rowspan="2">Manday (YTD)</td>
        <td colspan="1" rowspan="2">Remaining manday</td>
        <td colspan="1" rowspan="2">External costs</td>
      </tr>
      <tr>
        <td colspan="1">Jan</td>
        <td colspan="1">Feb</td>
        <td colspan="1">Mar</td>
        <td colspan="1">Apr</td>
        <td colspan="1">May</td>
        <td colspan="1">Jun</td>
        <td colspan="1">Jul</td>
        <td colspan="1">Aug</td>
        <td colspan="1">Sep</td>
        <td colspan="1">Oct</td>
        <td colspan="1">Nov</td>
        <td colspan="1">Dec</td>
      </tr>
    </thead>
    <tbody style="background-color: white">
      <tr id="getProject" *ngFor="let project of projectList">
        <td id="projectCode">{{ project[0] }}</td>
        <td id="projectName">{{ project[1] }}</td>
        <td id="manday">{{ project[2] }}</td>
        <td id="janManday">{{ project[3][0] }}</td>
        <td id="febManday">{{ project[3][1] }}</td>
        <td id="marManday">{{ project[3][2] }}</td>
        <td id="aprManday">{{ project[3][3] }}</td>
        <td id="mayManday">{{ project[3][4] }}</td>
        <td id="JunManday">{{ project[3][5] }}</td>
        <td id="JulManday">{{ project[3][6] }}</td>
        <td id="AugManday">{{ project[3][7] }}</td>
        <td id="SepManday">{{ project[3][8] }}</td>
        <td id="OctManday">{{ project[3][9] }}</td>
        <td id="NovManday">{{ project[3][10] }}</td>
        <td id="DecManday">{{ project[3][11] }}</td>
        <td id="totalManday">{{ project[4] }}</td>
        <td id="mandayYTD">{{ project[5] }}</td>
        <td id="remainingManday">
          {{ project[2] != 0 ? project[2] - project[5] : 0 }}
        </td>
        <td id="projectCostOnsite">{{ project[7] }}</td>
      </tr>
    </tbody>
  </table>

  <table hidden #tableMandayProjectV2 style="text-align: center">
    <thead style="background-color: whitesmoke">
      <tr>
        <th colspan="19">
          <h1 style="font-weight: bold">B3 Technology Co., Ltd</h1>
        </th>
      </tr>
      <tr>
        <td colspan="19">Time Sheet and Delivery</td>
      </tr>
      <tr>
        <td id="year" colspan="19">{{ year }} Project Manday Overview</td>
      </tr>
      <tr>
        <td colspan="1" rowspan="2">Project Code</td>
        <td colspan="1" rowspan="2">Project Name</td>
        <td colspan="1" rowspan="2">Project manager</td>
        <td colspan="1" rowspan="2">Initial Manday</td>
        <td colspan="1" rowspan="2">Adjust Manday1</td>
        <td colspan="1" rowspan="2">Adjust Manday2</td>
        <td colspan="1" rowspan="2">Adjust Manday3</td>
        <td colspan="1" rowspan="2">Total Manday</td>
        <td colspan="12" rowspan="1">Mandayที่ใช้ไป (รายเดือน)</td>
        <td colspan="1" rowspan="2">Mandayที่ใช้ไป (รวมทั้งปี)</td>
        <td colspan="1" rowspan="2">Manday (YTD)</td>
        <td colspan="1" rowspan="2">Remaining Manday</td>
        <td colspan="1" rowspan="2">Travel Expenses</td>
      </tr>
      <tr>
        <td colspan="1">Jan</td>
        <td colspan="1">Feb</td>
        <td colspan="1">Mar</td>
        <td colspan="1">Apr</td>
        <td colspan="1">May</td>
        <td colspan="1">Jun</td>
        <td colspan="1">Jul</td>
        <td colspan="1">Aug</td>
        <td colspan="1">Sep</td>
        <td colspan="1">Oct</td>
        <td colspan="1">Nov</td>
        <td colspan="1">Dec</td>
      </tr>
    </thead>
    <tbody>
      <td>
        <tr id="getProject" *ngFor="let project of projectListV2">
          <td id="projectCode">{{ project[0] }}</td>
          <td id="projectName">{{ project[1] }}</td>
          <td id="projectManager">{{ project[11] }}</td>
          <td id="initialManday">{{ project[2] }}</td>
          <td id="adjustManday1">{{ project[3] }}</td>
          <td id="adjustManday2">{{ project[4] }}</td>
          <td id="adjustManday3">{{ project[5] }}</td>
          <td id="totalManday">{{ project[6] }}</td>
          <td id="janManday">{{ project[7][0] }}</td>
          <td id="febManday">{{ project[7][1] }}</td>
          <td id="marManday">{{ project[7][2] }}</td>
          <td id="aprManday">{{ project[7][3] }}</td>
          <td id="mayManday">{{ project[7][4] }}</td>
          <td id="JunManday">{{ project[7][5] }}</td>
          <td id="JulManday">{{ project[7][6] }}</td>
          <td id="AugManday">{{ project[7][7] }}</td>
          <td id="SepManday">{{ project[7][8] }}</td>
          <td id="OctManday">{{ project[7][9] }}</td>
          <td id="NovManday">{{ project[7][10] }}</td>
          <td id="DecManday">{{ project[7][11] }}</td>
          <td id="totalManday">{{ project[8] }}</td>
          <td id="mandayYTD">{{ project[9] }}</td>
          <td id="remainingManday">
            {{ project[6] != 0 ? project[6] - project[9] : 0 }}
          </td>
          <td id="projectCostOnsite">{{ project[10] }}</td>
        </tr>
      </td>
    </tbody>
  </table>
  <!-- ##################################################################### -->
  <!-- <div class="container-fluid" style="padding-left: 20%; padding-right: 10%; padding-top: 10%;">
</div>
    <h2><strong>Verify Timesheet</strong></h2><br>
    <div class="container" id="main-container">
        <div class="row">
            <div class="col-xl-2 col-lg-6">
                <select class="form-control" [(ngModel)]="yearSelected" id="selectbasic" name="selectbasic">
                    <option *ngFor="let yearlist of yearList" [value]="yearlist">{{yearlist}}</option>
                </select>
            </div>
            <div class="col-xl-2 col-lg-6">
                <select class="form-control" [(ngModel)]="monthSelected" id="selectmonth" name="selectmonth">
                    <option *ngFor="let monthlist of monthList" [value]="monthlist">{{monthlist | month}}
                    </option>
                </select>
            </div>
            <div class="col-xl-2 col-lg-6">
                <input type="text" class="w-100 mb-4 mb-xl-0 px-3 py-2 form-control shadow-none text-dark"
                    placeholder="Name" [(ngModel)]="fullNameSelected" />
            </div>
            <div class="col-xl-2 col-lg-6">
                <select class="form-control" [(ngModel)]="statusSelected" id="selectbasic" name="selectbasic">
                    <option *ngFor="let statuslist of statusList" [value]="statuslist">
                        {{statuslist | status}}
                    </option>
                </select>
            </div>
            <div class="col-xl-3 col-lg-6 row">
                <button type="button" class="btn btn-primary">Search</button>
            </div>
        </div><br>
        <table class="table table-bordered">
            <thead>
                <tr>
                    <th style="width:3%" scope="col" class="text-center font-size">No</th>
                    <th style="width:30%" scope="col" class="text-center font-size">Employee</th>
                    <th style="width:15%" scope="col" class="text-center font-size">Month/Year</th>
                    <th style="width:20%" scope="col" class="text-center font-size">Status</th>
                    <th style="width:20%" scope="col" class="text-center font-size">Action</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let userMainTimesheetList of _userMainTimesheetList; let i = index">
                    <th scope="row" class="text-center font-size">{{(i+1) + indexpagingstart}}</th>
                    <td class="text-center font-size">{{userMainTimesheetList.firstName}}
                        {{userMainTimesheetList.lastName}}
                    </td>
                    <td class="text-center font-size">
                        <button type="button " class="btn btn-link"
                            (click)="goToViewVerifyTimesheet(userMainTimesheetList.id)">{{userMainTimesheetList.month
                            |
                            month}}/{{userMainTimesheetList.year}}</button>
                    </td>
                    <td class="text-center font-size">{{userMainTimesheetList.status | status}}</td>
                    <td class="text-center font-size">
                        <button [disabled]="userMainTimesheetList.status != 'P'" type="button" class="btn btn-success"
                            (click)="onClickApprove(userMainTimesheetList)">Approve</button>
                        &nbsp;&nbsp;&nbsp;&nbsp;
                        <button [disabled]="userMainTimesheetList.status != 'P'" type="button" class="btn btn-danger"
                            data-bs-toggle="modal" data-bs-target="#staticBackdrop"
                            (click)="onClickReject(userMainTimesheetList)">Reject</button>
                    </td>
                </tr>
            </tbody>
        </table>
        <span *ngIf="_userMainTimesheetList?.length == 0">
            <h2 class="h2-center">ไม่พบข้อมูล</h2>
        </span>
        <span *ngIf="_userMainTimesheetList?.length > 0">
            <nav aria-label="Page navigation example">
                <ul class="pagination justify-content-end">
                    <li class="page-item"><button class="page-link text-dark "
                            (click)="previousClick()">Previous</button></li>
                    <li *ngFor='let index of pageIndexes' class="page-item " [ngClass]="active(index)">
                        <button class="page-link text-dark " (click)="getPaginationWithIndex(index)">
                            {{index + 1}}
                        </button>
                    </li>

                    <li class="page-item"><button class="page-link text-dark " (click)="nextClick()">Next</button></li>
                </ul>
            </nav>
        </span>
    </div>
    <div class="modal fade" id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
        aria-hidden="true">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h2 class="modal-title" id="exampleModalLabel">Reject</h2>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" #closebutton
                        (click)="onCloseModel()"></button>
                </div>
                <div class="modal-body">
                    <form>
                        <div class="mb-3">
                            <label for="message-text" class="col-form-label">Reason:</label>
                            <textarea [(ngModel)]="reason" name="reject" class="form-control" id="message-text"
                                rows="6"></textarea>
                        </div>
                    </form>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"
                        (click)="onCloseModel()">Close</button>
                    <button type="button" class="btn btn-warning" (click)="onClickSave()">Save</button>
                </div>
            </div>
        </div>
    </div>
</div> -->